import { render } from "./FiltersDisplay.vue?vue&type=template&id=6c7af8d9&scoped=true"
import script from "./FiltersDisplay.vue?vue&type=script&lang=js"
export * from "./FiltersDisplay.vue?vue&type=script&lang=js"

import "./FiltersDisplay.vue?vue&type=style&index=0&id=6c7af8d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7af8d9"]])

export default __exports__